import { gql } from '@apollo/client'

export default gql`
    mutation createZipDownload(
        $name: String!
        $folderId: UUID
        $revisionIds: [UUID!]
        $attachmentIds: [UUID!]
        $quoteModelRevisionIds: [UUID!]
        $quoteAttachmentRevisionIds: [UUID!]
        $estimateItemIds: [UUID!]
    ) {
        createZipDownload(
            name: $name
            folderId: $folderId
            revisionIds: $revisionIds
            attachmentIds: $attachmentIds
            quoteModelRevisionIds: $quoteModelRevisionIds
            quoteAttachmentRevisionIds: $quoteAttachmentRevisionIds
            estimateItemIds: $estimateItemIds
        ) {
            id
            jobStartDate
            jobCompleteDate
            name
            error
            url
        }
    }
`
